import HtmlContent from "../ui/atoms/html/HtmlContent";

export const getFaqData = (t) => {
  return [
    {
      value: 1,
      title: "1. " + t("support.question1"),
      content: <HtmlContent html={t("support.answer1")} />,
    },
    {
      value: 2,
      title: "2. " + t("support.question2"),
      content: <HtmlContent html={t("support.answer2")} />,
    },
    {
      value: 3,
      title: "3. " + t("support.question3"),
      content: <HtmlContent html={t("support.answer3")} />,
    },
    {
      value: 4,
      title: "4. " + t("support.question4"),
      content: <HtmlContent html={t("support.answer4")} />,
    },
    {
      value: 5,
      title: "5. " + t("support.question5"),
      content: <HtmlContent html={t("support.answer5")} />,
    },
    {
      value: 6,
      title: "6. " + t("support.question6"),
      content: <HtmlContent html={t("support.answer6")} />,
    },
    {
      value: 7,
      title: "7. " + t("support.question7"),
      content: <HtmlContent html={t("support.answer7")} />,
    },
    {
      value: 8,
      title: "8. " + t("support.question8"),
      content: <HtmlContent html={t("support.answer8")} />,
    },
    {
      value: 9,
      title: "9. " + t("support.question9"),
      content: <HtmlContent html={t("support.answer9")} />,
    },
    {
      value: 10,
      title: "10. " + t("support.question10"),
      content: <HtmlContent html={t("support.answer10")} />,
    },
    {
      value: 11,
      title: `11. ` + t("support.question11"),
      content: <HtmlContent html={t("support.answer11")} />,
    },
    {
      value: 12,
      title: "12. " + t("support.question12"),
      content: <HtmlContent html={t("support.answer12")} />,
    },
    {
      value: 13,
      title: "13. " + t("support.question13"),
      content: <HtmlContent html={t("support.answer13")} />,
    },
  ];
};
